/* eslint-disable react/prop-types */
import { ReactNode, useEffect, useState } from 'react'

// import { MatchTag } from 'components/atoms/matchTag'
// import { IntlWrapper } from 'components/templates/appWrappers/intlWrapper'
// import { LOCALE } from '@hhgtech/hhg-components/types'
import type { AppProps } from 'next/app'
import dynamic from 'next/dynamic'
import LazyHydrate from 'react-lazy-hydration'

// import { useRouterExtend } from 'hooks/useRouterExtend'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { CATEGORIES_TO_ENABLE_MOMAGIC_ADS } from 'interfaces/constants/ads'
import { isInIframe } from 'utils/isInframe'

import { AppContextWrapper } from './appContextWrapper'
import { AppGlobalStyle } from './appGlobalStyle'
import ATSManager from './ATSManager'
import { DynamicIntlWrapper } from './dynamicIntlWrapper'
import { DynamicTranslationsWrapper } from './dynamicTranslationsWrapper'
import { GTMScript } from './GTMScript'
import { InSkinScript } from './inSkinScript'
import PWTWrapper from './pwtWrapper'
import { SSOV2Wrapper } from './SSOV2Wrapper'
import { getServicePageParams } from '../carePath/helpers'
// import ChatwootWidget from 'components/atoms/chatwoot'
// import { ZaloChat } from 'components/atoms/zaloChat'

const AppCustomScripts = dynamic(() =>
  import('./appCustomScripts').then((mod) => mod.AppCustomScripts),
)
// const MatchTag = dynamic(
//   () => import('components/atoms/matchTag').then((mod) => mod.MatchTag),
//   {
//     ssr: false,
//   },
// )
const AppCustomHooksWrapper = dynamic(
  () => import('./useAppCustomHooks').then((mod) => mod.AppCustomHooksWrapper),
  {
    ssr: false,
  },
)
const GoogleOneTap = dynamic(
  () => import('./googleOneTap').then((mod) => mod.GoogleOneTap),
  {
    ssr: false,
  },
)
const ZaloChat = dynamic(
  () => import('components/atoms/zaloChat').then((mod) => mod.ZaloChat),
  {
    ssr: false,
  },
)
const PerformanceMonitor = dynamic(
  () =>
    import('components/atoms/performanceMonitor').then(
      (mod) => mod.PerformanceMonitor,
    ),
  {
    ssr: false,
  },
)
const ChatwootWidget = dynamic(
  () => import('components/atoms/chatwoot').then((mod) => mod.default),
  {
    ssr: false,
  },
)
// const NotificationsHandler = dynamic(
//   () =>
//     import('components/molecules/notificationsHandler').then(
//       (mod) => mod.NotificationsHandler,
//     ),
//   {
//     ssr: false,
//   },
// )
const AppMantineProvider = dynamic(() =>
  import('./appMantineProvider').then((m) => m.AppMantineProvider),
)
const QuickBookingDrawerWrapper = dynamic(
  () =>
    import('components/organisms/quickBookingDrawer/wrapper').then(
      (m) => m.QuickBookingDrawerWrapper,
    ),
  {
    ssr: false,
  },
)

// declare let google: any
export default function AppWrapper({
  pageProps,
  children,
}: {
  pageProps?: AppProps<{
    page?: string
    customComponentTheme?: string
    disableAds?: boolean
  }>['pageProps']
  children: ReactNode
}) {
  const [loadIframe, setLoadIframe] = useState(false)
  const { disableAds } = pageProps || {}

  useEffect(() => {
    setLoadIframe(!isInIframe())
  }, [])

  const { locale, asPath } = useRouterExtend()

  return (
    <DynamicIntlWrapper>
      {/*
			// https://hhgdev.atlassian.net/browse/SEO-25
			<MatchTag /> */}

      {pageProps?.page !== 'dynamicSpotlight' && (
        <GTMScript servicePageTrackingParams={getServicePageParams()} />
      )}

      <DynamicTranslationsWrapper>
        <AppContextWrapper pageProps={pageProps as any}>
          <AppCustomHooksWrapper />
          <InSkinScript />
          <ATSManager />
          {loadIframe && (
            <>
              <AppCustomScripts />
              <GoogleOneTap />
            </>
          )}
          <AppMantineProvider
            customComponentTheme={pageProps?.customComponentTheme}
          >
            <AppGlobalStyle />
            {/* <MatchTag /> */}
            <LazyHydrate whenIdle>
              <QuickBookingDrawerWrapper />
            </LazyHydrate>
            {children}
            {!disableAds && (
              /* show inskin ads */
              <PWTWrapper
              // testAdpushup={
              //   locale === LOCALE.PhilippinesEnglish ||
              //   locale === LOCALE.PhilippinesTagalog
              // }
              />
            )}
            {(CATEGORIES_TO_ENABLE_MOMAGIC_ADS[locale] || []).find((i) =>
              encodeURIComponent(decodeURIComponent(asPath)).startsWith(
                encodeURIComponent(i),
              ),
            ) && (
              <script
                dangerouslySetInnerHTML={{
                  __html: `
                    // Wait for the DOM to load
                    document.addEventListener("DOMContentLoaded", function () {
                    // Delay of 3 seconds
                    setTimeout(function () {
                        // Array of IDs for the divs to hide
                        const adDivIds = [
                        "div-gpt-ad-1731038676058-0",
                        "TR-3520584e-9d88-11ef-9b9c-833c3a33225d"
                        ];
                        // Loop through each ID
                        adDivIds.forEach(function (id) {
                        const adDiv = document.getElementById(id);
                        if (adDiv) {
                            // Hide the div
                            adDiv.style.display = "none";
                            console.log("Ad div with ID " + id + " has been hidden.");
                        } else {
                            console.log("Ad div with ID " + id + " not found.");
                        }
                        });
                    }, 10000); // 10000ms = 10 seconds
                    });
                  `,
                }}
              />
            )}

            {/* <Acquisition /> */}
            {/* <LazyHydrate whenIdle>
              <NotificationsHandler />
            </LazyHydrate> */}
            <ZaloChat />
            <ChatwootWidget />
            <PerformanceMonitor />
            <SSOV2Wrapper />
          </AppMantineProvider>
        </AppContextWrapper>
      </DynamicTranslationsWrapper>
    </DynamicIntlWrapper>
  )
}
